import { Record } from 'immutable';

export default class RecruitmentStatusRecord extends Record({
  id: undefined,
  links: undefined,
  name: undefined,
  resourceCount: undefined,
  sort: undefined,
}) {
}
